// extracted by mini-css-extract-plugin
export default {"MenuContainer":"Ryd5L27u","Menu":"F5DiV_3R"};